/** The Solar finance type Credit Human financing saves as. */
export const SOLAR_CREDIT_HUMAN_FINANCE_TYPE = `credit_human`
/** The Solar finance type Concert financing saves as. */
export const SOLAR_CONCERT_FINANCE_TYPE = `concert`
/** The Finance Plan code of Solar's Sungage plan (BrightStar or Sunrise Escalator). */
export const SOLAR_SUNGAGE_FINANCE_TYPE = `sungage`
/** The Solar finance type LightReach saves as. */
export const SOLAR_LIGHTREACH_FINANCE_TYPE = `lightreach`

/** The lenders a Solar plan finances through; Cash and the rest have none. */
export type SolarLender =
  | typeof SOLAR_CONCERT_FINANCE_TYPE
  | typeof SOLAR_CREDIT_HUMAN_FINANCE_TYPE
  | typeof SOLAR_LIGHTREACH_FINANCE_TYPE
  | typeof SOLAR_SUNGAGE_FINANCE_TYPE

const SOLAR_LENDERS: readonly SolarLender[] = [
  SOLAR_CONCERT_FINANCE_TYPE,
  SOLAR_CREDIT_HUMAN_FINANCE_TYPE,
  SOLAR_LIGHTREACH_FINANCE_TYPE,
  SOLAR_SUNGAGE_FINANCE_TYPE,
]

/** The lender a finance type names, or null for Cash, another partner or none. */
export const solarLenderOfFinanceType = (
  financeType: string | null | undefined,
): SolarLender | null =>
  SOLAR_LENDERS.find((lender) => lender === financeType) ?? null

/** The lender of a financing read's stored plan, or null. */
export const solarLenderOf = (
  financing: { financePlan: { financeType: string } | null } | null | undefined,
): SolarLender | null =>
  solarLenderOfFinanceType(financing?.financePlan?.financeType)
